import PubSub from 'pubsub-js';

const $html = $('html');
const $targetIntersection = '.content.-insight .-intersection';
const $targetParent = $('.content.-insight');
const $contentTable = $('.content__table', $targetParent);
const $contentLink = $('.content__link', $targetParent);
const $contentNone = $('.content__none', $targetParent);
const $contentTableParent = $('.content__tableParent', $targetParent);

const ACTIVE_TIME = 1500;

const intersection = () => {
    const targets = document.querySelectorAll(`${$targetIntersection}`);

    const options = {
      root: null,
      rootMargin: '0px 0px',
      threshold: 0.5,
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!$(entry.target).hasClass('-intersectionIsEntry')) {
            $(entry.target).addClass('-intersectionIsEntry');
          }
        }
      });
    }, options);

    targets.forEach(target => {
      observer.observe(target);
    });
};

PubSub.subscribe('init', () => {
    const device = $html.data('device');
    if (device === 'mobile') {
        intersection();
    }

    // タイトルがひとつでも入ってなかったら非表示
    let count = 0;
    $('.content__tableItem', $targetParent).each((index, element) => {
      const title = $('.content__tableItem__text', element)
      if (title.text()) {
        count += 1;
      }
    });

    if (count <= 0) {
      $contentTableParent.addClass('-none');
    }
  });

PubSub.subscribe('top.insight.show', () => {
  $contentTable.addClass('-intersectionIsEntry');
  $contentLink.addClass('-intersectionIsEntry');
  $contentNone.addClass('-intersectionIsEntry');

  setTimeout(() => {
    $targetParent.addClass('-active');
  }, ACTIVE_TIME);
});

PubSub.subscribe('top.insight.hide', () => {
  $contentTable.removeClass('-intersectionIsEntry');
  $contentLink.removeClass('-intersectionIsEntry');
  $contentNone.removeClass('-intersectionIsEntry');

  $targetParent.removeClass('-active');
});